<template>
  <div>
    <search-list @findData="findData"></search-list>
    <div class="page-wrapper">
    <div class="mt20">
      <Button type="primary" @click.stop="toAddProject"
              v-p="{api:'project/saveBaseInfo'}"
      >添加项目</Button>
    </div>
    <div class="mt36 card-wrapper" style="padding: 0 5px">
      <card  v-for="(item,index) in dataList" class="crad" :projectData="item" :key="'keyA'+index" @deleteproject="deleteproject">
      </card>
    </div>
    <div style="padding-bottom: 100px">
      <Page :total="total" size="small" :current="current"  show-total transfer @on-change="changePage"
             class="mt20 fr"></Page>
    </div>
    </div>
  </div>
</template>
<script>
  import SearchList from './components/SearchList'
  import Card from './components/Card'
  import {list,selectCondition} from 'api/project'
  import {projectdelete} from "../../../api/project";

  export default {
    name: "project",
    components:{
      SearchList,
      Card
    },
    data(){
      return {
        // test:[1,2,3,4,5,6],
        total:0,
        current:1,
        dataList:[
        ],
        searchData: {
          cityCode: '',
          projectTypeCode: '',
          projectStatusCode: '',
          projectNameAndAddress: '',
          page: 1,
          limit: 10,
        }
      }
    },
    methods:{
      deleteproject(id,name){
        this.$Modal.confirm({
          // title:'',
          content:'<p>确认删除'+name+'项目吗？</p>',
          onOk:()=>{
            let params={
              projectFid:id

            };
            projectdelete(params).then(res=>{
              this.$Message.success('项目删除成功');
              this.current=1;
              this.searchData.page=1;
              this.initPageList()
            }).catch(error=>{})
          }
        })
      },
      toAddProject(){
        this.$router.push('addproject')
      },
      findData(params){
        this.searchData=Object.assign({},params);
        this.current=1;
        this.initPageList()
      },
      initPageList(){
        list(this.searchData).then(res => {
          this.dataList = res.data.rows;
          this.total=res.data.total
        }).catch(error=>{})
      },
      changePage(n){
        this.current=n;
        this.searchData.page=n;
        this.initPageList()
      }
    },
    created() {
      this.initPageList()
    }
  }
</script>

<style scoped>
  .crad{
    margin-bottom: 40px;
    margin-right: 24px;
  }
  .card-wrapper{
    display: flex;
    flex-wrap: wrap;
    /*justify-content: space-around;*/
    /*align-items: left;*/
  }

</style>
